import * as React from 'react'
import { Flex } from 'grid-styled'
import { Link } from 'gatsby'
import Img from 'gatsby-image'
import { Helmet } from 'react-helmet'
import Hero from '../../components/Hero'
import Button from '../../components/Button'
import BackgroundSection from '../../components/BackgroundSection'
import MainLayout from '../../components/Layout'
import { AboutContact } from '..'
import {
  BeforeAfter,
  StyledTabs,
  StyledTabList,
  StyledTab,
  Content,
  Video,
} from '../../components/procedures'
import { TabPanel } from 'react-tabs'

const content = {
  backgroundTitle: 'Other Non-Surgical Options',
  subtitle: `Trusted, Experienced & Ethical. Boutique plastic surgery on Sydney's North Shore.`,
  title: 'Dermal Fillers',
  otherOptions: [
    {
      text: 'Dermal Fillers',
      to: '/non-surgical/dermal-fillers',
    },
    // {
    //   text: 'Cool Sculpting',
    //   to: '/non-surgical/coolsculpting',
    // },
    {
      text: 'Skin Care',
      to: '/non-surgical/skin-treatments',
    },
    {
      text: 'Excess Underarm Sweating',
      to: '/non-surgical/excess-underarm-sweating',
    },
    {
      text: 'Anti-Wrinkle Injections',
      to: '/non-surgical/muscle-relaxants',
    },
    // {
    //   text: 'IPL & Laser Treatments',
    //   to: '/non-surgical/ipl-and-laser-treatments'
    // }
  ],
}

export default ({ data }) => (
  <MainLayout header="light">
    <Helmet>
      <title>{content.title} - Plastic Surgery Sydney</title>
      <meta
        name="description"
        content="With dermal fillers, you can smoothen wrinkles, and achieve a rejuvenated and youthful glow, which is something every woman aims for."
      />
    </Helmet>

    <Hero bgImage={data.womanWaterfall.childImageSharp} height="600px">
      <h1>{content.title}</h1>
      <p>{content.subtitle}</p>
      <Flex>
        <Button color="#fff" small={true} outline={true}>
          Learn more
        </Button>
      </Flex>
    </Hero>

    <Content>
      <h2>Dermal Fillers</h2>
      <h4>
        A rejuvenated and youthful glow is something every woman aims for,
        especially when it concerns the face.
      </h4>{' '}
      <p>
        With dermal fillers, you can soften wrinkles around the nasolabial lines
        (smile lines) and perioral lines (smokers lines above the upper lip),
        oral commissures (marionette lines), enlarge your lips or add volume to your cheeks. If you have hollowing under the eyes, dermal fillers can also be used in the tear trough area to give fullness and help eleviate dark circles.
      </p>
      <p>
        There are many dermal fillers available in the market, and the product
        consists of a stabilised, hyaluronic acid (naturally occurring in
        humans), in the form of a crystal-clear gel. The substance smoothes
        wrinkles and folds or gives contour to the skin. Dermal fillers are
        stable and bio-degradable, and do not contain animal acid. These
        qualities eliminate the risk of transmitting disease or inducing
        allergic reactions in patients sensitive to common foods such as beef,
        chicken, or eggs.
      </p>
      <h4>This treatment is designed to be used for the correction of:</h4>
      <ul>
        <li>Nasolabial lines (smile lines)</li>
        <li>Perioral lines (smokers lines above upper lip)</li>
        <li>Oral commissures and corners of mouth (marionette lines)</li>
        <li>Lip augmentation / enhancement (enlargement).</li>
        <li>Cheek enhancement and tear trough filling</li>
      </ul>
      <h4>The Procedure</h4>
      <p>
        The dermal filler gel comes in a pre-measured syringe, which is injected
        directly underneath the wrinkle needing treatment. The volume from the
        gel lifts and plumps out the line or wrinkle, making it appear smoother
        and less obvious. When used for enhancement or enlargement, the gel
        gives extra volume to the lips or cheeks. This plumps up and enhances
        the shape. Most clients report that the extra volume to the lip-line
        improves “lipstick bleeding” significantly.
      </p>
      <p>
        Mid-face cheek enhancement is a very popular treatment to give you a
        lift without surgery.
      </p>
      <p>
        Each treatment lasts between 6-24 months, depending on the site being
        treated and the thickness of the gel. There are a range of products
        designed to treat different areas of the face.
      </p>

      <h4>Possible risks include:</h4>
      <ul>
        <li>Acne-like skin eruptions</li>
        <li>Asymmetry</li>
        <li>Bleeding from the injection site</li>
        <li>Bruising</li>
        <li>Damage to the skin that results in a wound and possible scarring</li>
        <li>Infection at the injection site</li>
        <li>Lumps</li>
        <li>Palpability of the filler under the surface of the skin</li>
        <li>Skin necrosis (ulceration or loss of skin from disruption of blood flow)</li>
        <li>Skin rash with itching</li>
        <li>Skin redness</li>
        <li>Swelling</li>
        <li>Under- or over-correction of wrinkles</li>
      </ul>

      <p>In very rare cases, the filler may accidentally be injected into your blood vessels instead of under your skin. This can block blood flow. What happens if your blood flow is blocked will vary depending on where the block is. If your skin is affected, you might have skin loss or wounds. If your eye is affected, you might lose your eyesight or go blind.</p>

      <Link to="/contact/">
        <Button inverted={true}>Contact us today!</Button>
      </Link>
    </Content>
{/* 
    <Video
      videoId="ppeGMiuDsgw"
      opts={{
        height: '576',
        width: '1024',
        playerVars: {
          color: 'white',
          rel: 0,
        },
      }}
    />

    <Video
      videoId="BqmmhluQSo0"
      opts={{
        height: '576',
        width: '1024',
        playerVars: {
          color: 'white',
          rel: 0,
        },
      }}
    /> */}

    <BackgroundSection
      image={data.otherBreast.childImageSharp}
      title={content.backgroundTitle}
      height="500px"
      darkness="0.4"
    >
      <p style={{ fontSize: 18, margin: '-1rem 0 2rem' }}>
        Browse Dr. Graham Sellars' full range of surgical and non-surgical
        procedures.
      </p>
      {content.otherOptions.map(({ to, text }) => (
        <Flex mr={2} mb={3} style={{ float: 'left' }}>
          <Link to={to}>
            <Button small={true} color="#fff" outline={true}>
              {text}
            </Button>
          </Link>
        </Flex>
      ))}
    </BackgroundSection>

    <BeforeAfter>
      <h2>Before &amp; After</h2>
      <div>
        {data.allFile.edges
          .sort((x, y) => {
            if (
              x.node.childImageSharp === null ||
              y.node.childImageSharp === null
            ) {
              return 0
            }
            return x.node.childImageSharp.resolutions.src.localeCompare(
              y.node.childImageSharp.resolutions.src
            )
          })
          .map(
            (image) =>
              image.node.childImageSharp && (
                <Img resolutions={image.node.childImageSharp.resolutions} />
              )
          )}
      </div>
      <Flex justifyContent="center">
        <Link to="/gallery">
          <Button inverted={true}>See the full gallery</Button>
        </Link>
      </Flex>
    </BeforeAfter>

    <AboutContact data={data} />
  </MainLayout>
)
export const query = graphql`
  query DermalFillerQuery {
    allFile(filter: { relativeDirectory: { eq: "dermal-fillers" } }) {
      edges {
        node {
          childImageSharp {
            resolutions(width: 500, toFormat: JPG) {
              ...GatsbyImageSharpResolutions
            }
          }
        }
      }
    }
    womanWaterfall: file(relativePath: { eq: "botox.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 3000, quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    otherBreast: file(relativePath: { eq: "non-surgical-woman.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    asaps: file(relativePath: { eq: "ASAPS.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    asps: file(relativePath: { eq: "ASPS.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    drSellars: file(relativePath: { eq: "dr-graham-sellars.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    fracs: file(relativePath: { eq: "FRACS.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
